module.exports = __webpack_public_path__ + "static/caf91-export-eea459cec188ce9e4f47220ef4b96798.mp4";